import update from 'immutability-helper';
import { USER_ORDERS } from '../types';
const init = JSON.parse(localStorage.getItem('myProduct') || '[]')
export default function products(state = init, action) {
  switch (action.type) {
    case 'UPDATE_PRODUCT':
      return action.data;
    default:
      return state;
  }
}
